import * as types from './types';

/**
 * Set User Data
 */
export function setUserData(user) {
  return (dispatch) => {
    /*
        Set User Data
         */
    dispatch({
      type: types.SET_USER_DATA,
      payload: user,
    });
  };
}

/**
 * Remove User Data
 */
export function removeUserData() {
  return {
    type: types.REMOVE_USER_DATA,
  };
}
